import React from "react";
import "./Footer.scss";
import logo from "../img/ISLE.png";
import { Link, useNavigate } from "react-router-dom";
import { HashLink } from "react-router-hash-link";

const Footer = () => {
  const navigate = useNavigate();

  return (
    <>
      <footer id="footer" className="footer">
        <div className="footer-content">
          <div className="container">
            <div className="row  footer-all">
              <div className="col-lg-2  col-md-4 footer-info">
                <Link to="/" className="logo">
                  <img
                    src={logo}
                    alt="ISLE"
                    title="ISLE"
                    className="mb-5 logoisle"
                    style={{
                      width: "90px",
                      height: "90px",
                      objectFit: "cover",
                      borderRadius: "25px 0 25px 0",
                    }}
                  />
                </Link>
              </div>
              <div className="col-lg-2 col-md-4 col-sm-4 footer-links">
                <h4>Quick Links</h4>
                <ul>
                  <li>
                    <HashLink className="li" smooth to="/aboutus">
                      About Us
                    </HashLink>
                  </li>
                  <li>
                    <HashLink className="li" smooth to="/magazine">
                      Magazine
                    </HashLink>
                  </li>
                  <li>
                    <HashLink className="li" smooth to="/members">
                      Members
                    </HashLink>
                  </li>
                  <li>
                    <Link className="li" to="/contactus">
                      Contact Us
                    </Link>
                  </li>
                </ul>
              </div>
              <div className="footer-links col-lg-3 col-md-4 col-sm-4 footer-contact text-center text-md-start">
                <h4 className="">Contact Us</h4>

                <div className="contact-left">
                  <div className="mails text-start">
                    <p>tresurer@isle-mp.org</p>
                    <p>secretary@isle-mp.org</p>
                    <p>chairman@isle-mp.org</p>
                  </div>
                </div>
                <br />
              </div>
              <div className="footer-links col-lg-3  col-md-4 col-sm-4 footer-contact text-center text-md-start">
                <h4 className="">Phone</h4>

                <div className="contact-left">
                  <div className="phoneNum text-start">
                    <p>+91 94259-01926</p>
                    <p>+91 98930-18844</p>
                    <p>+91 94250-55626</p>
                  </div>
                </div>
              </div>
              <div className="footer-links col-lg-2 col-md-4 col-sm-8 footer-contact text-center text-md-start">
                <h4 className="te">Contact Person</h4>
                <address className="contact-left">
                  <div className="mails text-start">
                    <b>Mr. Swapnil Sharma</b>
                    <p className="m-0">+91 81038-37474</p>
                    <p className="m-0">info@isle-mp.org</p>
                    <p className="m-0">isleindore@gmail.com</p>
                  </div>
                </address>
              </div>
            </div>
            <address className="fs-6   m-0">
              {" "}
              <b className="address">Address :- </b> A-15, Block-3 New Siyaganj,
              Madhya Pradesh Indore-452006.
            </address>
          </div>
        </div>
        <div className="footer-legal  p-0 pb-4">
          <div className="container">
            <div
              className="copyright cursor-pointer"
              style={{ cursor: "pointer" }}
              onClick={(event) => {
                if (event.ctrlKey || event.metaKey || event.button === 1) {
                  // If Ctrl (or Command on macOS) or middle mouse button is clicked
                  const newTabUrl = "https://www.ehawkers.co.in/";
                  window.open(newTabUrl, "_blank"); // Open in a new tab
                } else {
                  // Default behavior for normal left-click
                  window.scrollTo(0, 0); // Scroll to the top of the page
                  window.location.href = "https://www.ehawkers.co.in/"; // Navigate to the URL
                }
              }}
            >
              <span id="copyright">
                <script>
                  document.getElementById('copyright').appendChild(document.createTextNode(new
                  Date().getFullYear()))
                </script>
              </span>
              &copy; Copyright
              <span> E-hawkers </span>. All Rights Reserved
            </div>
          </div>
        </div>
      </footer>
    </>
  );
};

export default Footer;
